import getMailItemSortByProperty from '../../../utils/tables/getMailItemSortByProperty';
import onLoadInitialRowsSucceeded from '../onLoadInitialRowsSucceeded';
import { action } from 'satcheljs/lib/legacy';
import { findItemWithStartIndex } from 'owa-mail-store';
import { getBaseFolderId } from 'owa-mail-list-store';
import { getMailboxInfoFromTableQuery } from 'owa-mail-mailboxinfo';
import { INITIAL_LOAD_ROW_COUNT } from '../../data-loading/TableLoadingConstants';
/**
 * Load the initial items from the server
 * @param tableView to load items in
 * @param OnInitialTableLoadComplete is a callback that is called when we receive the response
 * The callback is handled by table loading
 * @param isTablePrefetched indicates if the table is prefetched
 * @return a promise that resolves when the load table from server has completed
 */
export default action('loadInitialItemsFromServer')(function loadInitialItemsFromServer(tableView, isTablePrefetched, onInitialTableLoadComplete) {
    var mailTableQuery = tableView.tableQuery;
    return findItemWithStartIndex(getBaseFolderId(mailTableQuery), 0 /* startIndex */, INITIAL_LOAD_ROW_COUNT, mailTableQuery.viewFilter, getMailItemSortByProperty(mailTableQuery), mailTableQuery.focusedViewFilter, mailTableQuery.requestShapeName, mailTableQuery.shouldTryToUseSessionDataResponse, getMailboxInfoFromTableQuery(mailTableQuery).requestOptions, mailTableQuery.categoryName).then(function (responseMessage) {
        var returnedPromise = Promise.resolve();
        // Flag indicating whether the we're already showing cached results on the table before the refresh of top items
        var tableHasCachedItems = tableView.rowKeys.length > 0;
        var isSuccessResponseClass = responseMessage.ResponseClass == 'Success';
        if (isSuccessResponseClass) {
            onLoadInitialRowsSucceeded(tableView, responseMessage.RootFolder.Items, responseMessage.RootFolder.TotalItemsInView, responseMessage.SearchFolderId, null /* FolderId used for groups scenario, we currently don't support message view in groups. */);
        }
        else {
            var error = new Error("ResponseCode=" + responseMessage.ResponseCode + ", Stacktrace=" + responseMessage.StackTrace);
            error.fetchErrorType = 'ServerFailure';
            returnedPromise = Promise.reject(error);
        }
        onInitialTableLoadComplete(tableView, isSuccessResponseClass, responseMessage.ResponseCode, isTablePrefetched, tableHasCachedItems);
        return returnedPromise;
    }, function (error) {
        // Server returned non-200 response
        var responseCode = (error && error.response && error.response.status) || '';
        onInitialTableLoadComplete(tableView, false /* isSuccessResponseClass */, responseCode, isTablePrefetched, tableView.rowKeys.length > 0);
        return Promise.reject(error);
    });
});
//# sourceMappingURL=loadInitialItemsFromServer.js.map